import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { 
  ArrowLeft, 
  Phone, 
  Mail, 
  CheckCircle2, 
  Users, 
  Plug, 
  Coffee, 
  Accessibility, 
  ChevronLeft, 
  ChevronRight,
  Info,
  X,
  Maximize2
} from 'lucide-react';
import { Section } from '../components/ui/Common.jsx';
import { companyInfo, services } from '../data.js';
import ResponsiveImage from '../components/ui/ResponsiveImage.jsx';

// Bus data with specifications and correct image URLs
const busFleet = [
  {
    id: "man-lions-coach",
    name: "Man - Lion’s Coach L",
    type: "Luksus Turistbus",
    seats: "56 siddepladser",
    features: [
      { text: "Turistbus af højeste standard", icon: Info },
      { text: "56 komfortable siddepladser", icon: Users },
      { text: "220V stik samt USB ved alle sæder", icon: Plug },
      { text: "Toilet ombord", icon: CheckCircle2 },
      { text: "Kaffemaskine", icon: Coffee }
    ],
    images: [
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/6f8df608-50d7-49fd-8ee2-b12da9722b32.jpg", // Man - Klitter
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/1cf1f82b-94a2-406d-863c-258544a18039.jpg", // MAN7
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/00ee5cd9-7c9e-43e3-beee-670207d8e40a.jpg", // MAN5
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/fce1a48e-e7ee-40e2-918b-c9f19cc2040c.jpg", // MAN4
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/6403e959-55c6-477d-a473-e59b49e14858.jpg"  // MAN3
    ]
  },
  {
    id: "vdl-jonckheere",
    name: "VDL – Jonckheere",
    type: "Turistbus med lift",
    seats: "47 siddepladser",
    features: [
      { text: "47 komfortable siddepladser", icon: Users },
      { text: "Udstyret med lift til kørestolsbrugere", icon: Accessibility },
      { text: "Plads til 1 kørestol ombord", icon: Accessibility },
      { text: "Toilet ombord", icon: CheckCircle2 },
      { text: "Kaffemaskine", icon: Coffee }
    ],
    images: [
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/9d90002e-0388-4129-ad13-b44afe44b033.jpg",
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/ca8a0cda-9889-4aaa-bd81-e4f0fdad9171.jpg", // DAF3
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/29aac52c-0092-4646-8e77-89be9dfc02f6.jpg", // DAF1
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/6e083314-6c17-4f6f-af51-6113bc87cd8a.jpg",  // DAF2
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/cac75b66-aa8b-4ab7-bba0-fa81a1e8e6cc.jpg",
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/0097f861-a24d-4081-8d3c-972bac4d286e.jpg"
    ]
  },
  {
    id: "volvo-8700",
    name: "Volvo – 8700",
    type: "Skole- og udflugtsbus",
    seats: "46 siddepladser",
    features: [
      { text: "46 regulære siddepladser", icon: Users },
      { text: "11 integrerede børnesæder m. sele", icon: CheckCircle2 },
      { text: "Ideel til skoler, institutioner og kortere ture", icon: Info }
    ],
    images: [
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/9dbe85dc-bd4c-4b77-b59d-ce0c6260f688.jpg", // Volvo
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/f005f643-a1ac-4a7e-bd8d-b66894b772e5.jpg", // Volvo2
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/377ec550-c0ef-479d-8e6b-476c2e1a7db2.jpg"  // Volvo3
    ]
  },
  {
    id: "mb-graa-sprinter",
    name: "Mercedes Benz – Grå Sprinter",
    type: "Turist-minibus med lift",
    seats: "19 siddepladser",
    features: [
      { text: "Turistmodel med høj komfort", icon: Info },
      { text: "19 behagelige siddepladser", icon: Users },
      { text: "Udstyret med lift til kørestolsbrugere", icon: Accessibility }
    ],
    images: [
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/8435e7b9-b9de-49e2-8a78-0014c67ffe21.jpg",
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/d6ed3de1-8c11-47a7-925a-431a10c79ded.jpg",
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/29e98610-ad11-4545-acf1-897dc2dcb3e7.jpg",
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/1b99e7d4-b0d0-45a1-8698-f3a307283317.jpg",
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/4a1692bf-b373-432f-a0ff-9795cfa36e06.jpg",
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/687caf1a-c71d-493a-851b-178ab51882e3.jpg",
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/f648e486-4a97-4c25-96fb-15efb953ae85.jpg"
    ]
  },
  {
    id: "mb-blaa-sprinter",
    name: "Mercedes Benz – Blå Sprinter",
    type: "Minibus med lift",
    seats: "19 siddepladser",
    features: [
      { text: "19 siddepladser", icon: Users },
      { text: "Udstyret med lift til kørestolsbrugere", icon: Accessibility }
    ],
    images: [
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/ad6600ce-9f30-46d8-8307-f710b68645f7.png",
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/4ee97080-00b2-491f-8538-2038f0cf8760.jpeg",
      "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/de2021ef-608b-44b8-8f6e-703686bb3a92.png"
    ]
  }
];

export default function Turistkoersel() {
  const serviceId = "turist";
  const [activeBusIdx, setActiveBusIdx] = useState(0);
  const [activeImgIdx, setActiveImgIdx] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImgIdx, setLightboxImgIdx] = useState(0);

  const thumbnailsRef = useRef(null);
  const activeBus = busFleet[activeBusIdx];

  const handleBusChange = (idx) => {
    setActiveBusIdx(idx);
    setActiveImgIdx(0);
  };

  const nextImage = () => {
    setActiveImgIdx((prev) => (prev + 1) % activeBus.images.length);
  };

  const prevImage = () => {
    setActiveImgIdx((prev) => (prev - 1 + activeBus.images.length) % activeBus.images.length);
  };

  const nextLightboxImage = () => {
    setLightboxImgIdx((prev) => (prev + 1) % activeBus.images.length);
  };

  const prevLightboxImage = () => {
    setLightboxImgIdx((prev) => (prev - 1 + activeBus.images.length) % activeBus.images.length);
  };

  const scrollThumbnails = (direction) => {
    if (thumbnailsRef.current) {
      const scrollAmount = 160;
      thumbnailsRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  // Keyboard navigation for lightbox
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;
      if (e.key === 'Escape') setLightboxOpen(false);
      if (e.key === 'ArrowRight') nextLightboxImage();
      if (e.key === 'ArrowLeft') prevLightboxImage();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen, activeBusIdx]);

  return (
    <>
      <Helmet>
        <title>Turistkørsel | Sydthy Taxi & Turistfart ApS</title>
        <meta name="description" content="Turistkørsel i Hurup Thy. Vi tilbyder transport af jer alle - uanset antal og transportbehov. Moderne turistbusser med plads op til 56 passagerer." />
      </Helmet>

      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[400px] w-full overflow-hidden">
        <div className="absolute inset-0">
          <ResponsiveImage
            src="https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/fe3e4055-2bb4-448a-aca0-3e4696171427.jpg"
            alt="Turistkørsel"
            className="h-full w-full object-cover"
            sizes="100vw"
          />
          <div className="absolute inset-0 bg-slate-900/60" />
        </div>
        <div className="container relative z-10 mx-auto flex h-full items-end pb-20 px-4 md:px-6">
          <div className="max-w-3xl">
            <Link
              to="/"
              className="mb-8 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-blue-400 hover:text-blue-300"
            >
              <ArrowLeft className="h-4 w-4" /> Tilbage til forsiden
            </Link>
            <h1 className="text-5xl font-bold text-white md:text-6xl">Turistkørsel</h1>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <Section>
        <div className="grid gap-16 lg:grid-cols-3">
          <div className="lg:col-span-2 space-y-16">
            
            {/* Section 1 */}
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-slate-900">Turistkørsel i Hurup Thy</h2>
              <p className="text-lg text-slate-600 leading-relaxed">
                Planlægger du et arrangement hvor der er behov for transport af deltager?
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Så kontakt os og lad os hjælpe med planlægningen, så I får den helt rigtige løsning med turistkørsel.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Sydthy Taxi & Turistfart ApS tilbyder jer at tilrettelægge turen fra start til slut, i tæt samarbejde med jer. Vi kan tilbyde transport af jer alle - uanset antal og transportbehov.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Vi har en bred vognpark med minibusser og store turistbusser med plads op til 56 passagerer, så der er garanti for I alle kan komme samlet afsted.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Du finder Sydthy Taxi & Turistfart ApS i Hurup Thy.
              </p>
              <p className="text-lg font-medium text-slate-800 leading-relaxed">
                Lad os arrangere turistkørslen fra start til slut, så I kan slappe af og nyde turen.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <ResponsiveImage src="https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/9d90002e-0388-4129-ad13-b44afe44b033.jpg" alt="Turistbus interiør" className="w-full h-64 object-cover shadow-md" sizes="(max-width: 768px) 50vw, 400px" />
              <ResponsiveImage src="https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/40b475d2-03ca-408e-9c97-06fdbe35202b.jpg" alt="Turistbus sæder" className="w-full h-64 object-cover shadow-md" sizes="(max-width: 768px) 50vw, 400px" />
            </div>

            {/* Vores Vognpark Section (Interactive Fleet) */}
            <div className="space-y-8 bg-slate-50 p-6 md:p-8 border border-slate-100" data-dev-id="src/pages/Turistkoersel.jsx:200:12">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-200 pb-4">
                <h2 className="text-3xl font-bold text-slate-900">Vores Vognpark</h2>
                <span className="inline-flex items-center gap-2 text-xs font-bold text-blue-600 bg-blue-50 border border-blue-100 px-3 py-1.5 rounded-full self-start sm:self-auto">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-600"></span>
                  </span>
                  Klik på en bus for at se detaljer & billeder
                </span>
              </div>

              {/* Bus Tabs */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2.5">
                {busFleet.map((bus, idx) => (
                  <button
                    key={bus.id}
                    onClick={() => handleBusChange(idx)}
                    className={`px-4 py-3.5 text-sm font-bold transition-all cursor-pointer rounded-lg text-center border flex flex-col justify-center items-center gap-1 ${
                      activeBusIdx === idx
                        ? "bg-blue-600 text-white border-blue-600 shadow-md shadow-blue-100 scale-[1.02]"
                        : "bg-white text-slate-700 hover:bg-slate-50 border-slate-200 hover:border-slate-300 hover:scale-[1.01]"
                    }`}
                  >
                    <span className="break-words w-full">{bus.name}</span>
                    <span className={`text-[11px] font-medium transition-colors ${activeBusIdx === idx ? 'text-blue-100' : 'text-slate-500'}`}>
                      {bus.seats}
                    </span>
                  </button>
                ))}
              </div>

              {/* Active Bus Details (Text above, image below for wider view) */}
              <div className="space-y-6">
                
                {/* Specifications Card (Now placed above the images) */}
                <div className="bg-white p-6 border border-slate-200 shadow-xs">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border-b border-slate-100 pb-4 mb-4">
                    <div>
                      <span className="text-xs font-bold uppercase tracking-wider text-blue-600">
                        {activeBus.type}
                      </span>
                      <h3 className="text-2xl font-bold text-slate-900 mt-1">
                        {activeBus.name}
                      </h3>
                    </div>
                    <div className="bg-blue-50 text-blue-700 px-4 py-2 text-sm font-bold self-start sm:self-auto rounded-xs">
                      {activeBus.seats}
                    </div>
                  </div>
                  
                  <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                    {activeBus.features.map((feat, idx) => {
                      const IconComponent = feat.icon;
                      return (
                        <li key={idx} className="flex items-center gap-3 text-slate-700 bg-slate-50 p-3 border border-slate-100 rounded-xs">
                          <IconComponent className="h-5 w-5 text-blue-600 shrink-0" />
                          <span className="text-sm font-semibold">{feat.text}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                {/* Image Gallery Viewer (Now full width and wider!) */}
                <div className="space-y-4">
                  <div 
                    onClick={() => {
                      setLightboxImgIdx(activeImgIdx);
                      setLightboxOpen(true);
                    }}
                    className="relative h-[380px] md:h-[480px] w-full overflow-hidden bg-slate-900 cursor-pointer group rounded-xs shadow-sm"
                  >
                    <ResponsiveImage
                      src={activeBus.images[activeImgIdx]}
                      alt={`${activeBus.name} - billede ${activeImgIdx + 1}`}
                      className="h-full w-full object-cover transition-all duration-500 group-hover:scale-102"
                      sizes="(max-width: 1024px) 100vw, 800px"
                    />
                    
                    {/* Hover Zoom Overlay */}
                    <div className="absolute inset-0 bg-black/25 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                      <div className="bg-black/70 text-white px-4 py-2.5 flex items-center gap-2 text-sm font-semibold backdrop-blur-xs rounded-xs">
                        <Maximize2 className="h-4 w-4" />
                        Klik for at se i fuld skærm
                      </div>
                    </div>

                    {activeBus.images.length > 1 && (
                      <>
                        <button
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent opening lightbox when clicking arrows
                            prevImage();
                          }}
                          className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2.5 rounded-full transition-colors z-10 cursor-pointer"
                          aria-label="Forrige billede"
                        >
                          <ChevronLeft className="h-6 w-6" />
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent opening lightbox when clicking arrows
                            nextImage();
                          }}
                          className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2.5 rounded-full transition-colors z-10 cursor-pointer"
                          aria-label="Næste billede"
                        >
                          <ChevronRight className="h-6 w-6" />
                        </button>
                      </>
                    )}

                    <div className="absolute bottom-4 right-4 bg-black/60 text-white text-xs px-3 py-1.5 font-semibold rounded-xs">
                      {activeImgIdx + 1} / {activeBus.images.length}
                    </div>
                  </div>

                  {/* Thumbnails with elegant scroll buttons */}
                  {activeBus.images.length > 1 && (
                    <div className="relative flex items-center group/thumbs px-1">
                      {/* Left Scroll Button */}
                      <button
                        onClick={() => scrollThumbnails('left')}
                        className="absolute left-2 z-10 bg-white hover:bg-slate-50 text-slate-800 p-2 shadow-md border border-slate-200 rounded-full transition-all opacity-0 group-hover/thumbs:opacity-100 cursor-pointer"
                        aria-label="Scroll venstre"
                      >
                        <ChevronLeft className="h-4 w-4" />
                      </button>

                      {/* Thumbnails Container */}
                      <div 
                        ref={thumbnailsRef}
                        className="flex gap-2 overflow-x-auto pb-2 scroll-smooth w-full [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
                      >
                        {activeBus.images.map((img, idx) => (
                          <button
                            key={idx}
                            onClick={() => setActiveImgIdx(idx)}
                            className={`relative h-16 w-24 shrink-0 overflow-hidden border-2 transition-all rounded-xs cursor-pointer ${
                              activeImgIdx === idx 
                                ? "border-blue-600 scale-95 shadow-xs" 
                                : "border-transparent opacity-70 hover:opacity-100"
                            }`}
                          >
                            <ResponsiveImage src={img} alt="Miniature" className="h-full w-full object-cover" sizes="100px" />
                          </button>
                        ))}
                      </div>

                      {/* Right Scroll Button */}
                      <button
                        onClick={() => scrollThumbnails('right')}
                        className="absolute right-2 z-10 bg-white hover:bg-slate-50 text-slate-800 p-2 shadow-md border border-slate-200 rounded-full transition-all opacity-0 group-hover/thumbs:opacity-100 cursor-pointer"
                        aria-label="Scroll højre"
                      >
                        <ChevronRight className="h-4 w-4" />
                      </button>
                    </div>
                  )}
                </div>

              </div>
            </div>

            {/* Section 2 */}
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-slate-900">Turistkørsel til alle uanset antal</h2>
              <p className="text-lg text-slate-600 leading-relaxed">
                Vi kører med dagplejer, børnehaver, skoler, foreninger, virksomheder, private selskaber m. fl. både i ind- og udland. Til de yngste børn er busserne udstyret med godkendte børnestole.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Vores moderne turistbusser er indrettet med tanke på alles komfort og sikkerhed.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Når det kommer til udflugter for pensionister, kan du nyde godt af turistbusser med komfortable sæder, god støtte og udsyn, så de kan slappe af og nyde landskabet på vejen.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Og for kørestolsbrugerne er vores busser udstyret med lift, som gør det let og bekvemt at komme på og af bussen og deltage i eventyret.
              </p>
              <div className="flex gap-3 items-center bg-blue-50 p-4 text-blue-900 font-semibold">
                <CheckCircle2 className="h-6 w-6 shrink-0 text-blue-600" />
                Der er plads til op til 56 personer i vore turistbusser.
              </div>
              <p className="text-lg text-slate-600 leading-relaxed">
                På turen tilbyder vi at arrangere kaffe, rundstykke, frokost - medbragt eller på et hyggeligt spisested. Måske aftensmad på en hyggelig kro, eller....?
                <br />
                Lad os klare alt det praktiske, så I kan nyde turen.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Uanset alder eller behov kan I være sikre på, at vores turistkørsel vil gøre jeres tur så behagelig og mindeværdig som muligt.
              </p>
            </div>

            <ResponsiveImage 
              src="https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/morsa-2.png" 
              alt="Morsø Turistfart vognpark" 
              className="w-full h-80 object-cover rounded-lg shadow-md" 
              sizes="(max-width: 1024px) 100vw, 800px" 
            />

            {/* Section 3 */}
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-slate-900">Turistkørsel med professionelle chauffører og den bedste service</h2>
              <p className="text-lg text-slate-600 leading-relaxed">
                Når du bestiller en bus fra Sydthy Taxi & Turistfart ApS, kan I forvente en service ud over det sædvanlige. Vores chauffører er erfarne og kyndige, og de vil gå langt for at sikre, at jeres tur er problemfri og behagelig. Fra at hjælpe med planlægning af ruten til at give lokale tips og anbefalinger, er vores chauffører dedikerede til at give jer en uforglemmelig oplevelse med turistkørsel.
              </p>
            </div>

            {/* Section 4 */}
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-slate-900">Sikker og komfortabel turistkørsel - book i dag</h2>
              <p className="text-lg text-slate-600 leading-relaxed">
                Når I kører med os, er jeres sikkerhed vores højeste prioritet. Vi går ikke på kompromis med komforten – vores busser er rummelige, veludstyrede og designet til at give jer den bedst mulige oplevelse.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Så bestil jeres turistkørsel i dag.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Du kan ringe til os på telefon {companyInfo.phone} eller sende en mail til {companyInfo.email} eller du kan udfylde vores kontaktformular, så vender vi hurtigst muligt tilbage.
              </p>
            </div>

            <div>
              <ResponsiveImage src="https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/4d8e8cd0-d9e6-46f2-9119-009114caf84e.jpg" alt="Turistbus forfra" className="w-full h-96 object-cover object-[center_65%] shadow-md" sizes="(max-width: 1024px) 100vw, 1200px" />
            </div>

          </div>

          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="sticky top-32 space-y-8">
              <div className="bg-slate-900 p-8 text-white">
                <h3 className="mb-6 text-2xl font-bold">Bestil transport</h3>
                <p className="mb-8 text-slate-400">
                  Kontakt os for et uforpligtende tilbud eller for at booke din næste tur med det samme.
                </p>
                <div className="space-y-4">
                  <a
                    href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                    className="flex w-full items-center justify-center gap-3 bg-blue-600 py-4 font-bold transition-colors hover:bg-blue-700"
                  >
                    <Phone className="h-5 w-5" />
                    Ring {companyInfo.phone}
                  </a>
                  <a
                    href={`mailto:${companyInfo.email}`}
                    className="flex w-full items-center justify-center gap-3 border border-white/20 py-4 font-bold transition-colors hover:bg-white/10"
                  >
                    <Mail className="h-5 w-5" />
                    Send en mail
                  </a>
                </div>
              </div>

              <div className="bg-slate-50 p-8 border border-slate-200">
                <h4 className="mb-4 font-bold">Andre ydelser</h4>
                <ul className="space-y-3">
                  {services
                    .filter((s) => s.id !== serviceId)
                    .map((s) => (
                      <li key={s.id}>
                        <Link
                          to={s.id === 'taxa' ? '/taxa' : `/ydelser/${s.id}`}
                          className="flex items-center justify-between text-slate-600 hover:text-blue-600 transition-colors"
                        >
                          {s.title}
                          <ArrowLeft className="h-4 w-4 rotate-180" />
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div className="fixed inset-0 z-50 bg-black/95 flex flex-col items-center justify-center p-4 select-none">
          {/* Close Button */}
          <button
            onClick={() => setLightboxOpen(false)}
            className="absolute top-4 right-4 text-white/80 hover:text-white p-2.5 bg-white/10 hover:bg-white/20 rounded-full transition-all z-55 cursor-pointer"
            aria-label="Luk visning"
          >
            <X className="h-6 w-6" />
          </button>

          {/* Main Lightbox Image Container */}
          <div className="relative max-w-5xl w-full flex items-center justify-center">
            {activeBus.images.length > 1 && (
              <button
                onClick={prevLightboxImage}
                className="absolute left-2 md:left-4 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all z-55 cursor-pointer"
                aria-label="Forrige billede"
              >
                <ChevronLeft className="h-8 w-8" />
              </button>
            )}

            <img
              src={activeBus.images[lightboxImgIdx]}
              alt={`${activeBus.name} - fuld størrelse ${lightboxImgIdx + 1}`}
              className="max-h-[80vh] max-w-full object-contain shadow-2xl rounded-xs"
            />

            {activeBus.images.length > 1 && (
              <button
                onClick={nextLightboxImage}
                className="absolute right-2 md:right-4 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all z-55 cursor-pointer"
                aria-label="Næste billede"
              >
                <ChevronRight className="h-8 w-8" />
              </button>
            )}
          </div>

          {/* Lightbox Footer Info */}
          <div className="mt-6 text-center text-white">
            <h4 className="font-bold text-lg">{activeBus.name}</h4>
            <p className="text-sm text-slate-400 mt-1">
              Billede {lightboxImgIdx + 1} af {activeBus.images.length}
            </p>
          </div>
        </div>
      )}
    </>
  );
}
